export default "__VITE_ASSET__CYrtM2V0__"